<div class="row">
    <div class="col-xxl-6 col-md-12 d-flex align-items-stretch" *ngFor="let provider of providerKeys; let i = index">
        <div class="card info-card customers-card">
            <div class="filter">
                <a class="icon" href="#" data-bs-toggle="dropdown"><i class="bi bi-three-dots"></i></a>
                <ul class="dropdown-menu dropdown-menu-end dropdown-menu-arrow">
                    <li class="dropdown-header text-start">
                    <h6>Filter</h6>
                    </li>
        
                    <li *ngFor="let R of filterDataLabels;let i = index;">
                    <!-- <a class="dropdown-item" (click)="dataFilterBySelection(R.id); $event.stopPropagation()">{{R.duration}}</a> -->
                     <a class="dropdown-item" (click)="dataFilterBySelection(provider, R.id); 
                     $event.stopPropagation()">{{R.duration}}</a>
                    </li>
                </ul>
            </div>
            <div class="card-header">
                <h4>Internet speed of {{getProviderLabel(provider)}}</h4>
            </div>
            <div class="card-body">
                <div class="chart-container chart-wrapper">
                    <canvas #ispeedCanvas></canvas>
                </div>
            </div>
        </div>
    </div>
</div>




